// Portfolio data

export const portfolioData = {
  // Hero Section
  hero: {
    name: "Sanjana Kancharla",
    title: "Full Stack Software Developer",
    subtitle: "Building enterprise-level applications and AI-powered services",
    description: "Passionate developer with 4+ years of experience designing robust REST APIs, building AI-powered services, and automating enterprise workflows.",
    cta: {
      primary: "View My Work",
      secondary: "Get In Touch"
    }
  },

  // About Section
  about: {
    title: "About Me",
    bio: "I'm a Full Stack Software Developer with expertise in building enterprise-level applications and AI-powered services. I've worked on designing and delivering robust REST APIs, implementing end-to-end observability, and automating complex business workflows. I'm passionate about leveraging modern technologies like Spring AI, RAG pipelines, and cloud platforms to solve real-world problems.",
    highlights: [
      "4+ years of professional software development experience",
      "Built AI-powered services using Spring AI, RAG pipelines & LLMs",
      "Expert in Java, Spring Boot, Angular, and cloud platforms",
      "Strong focus on observability, automation, and clean architecture"
    ]
  },

  // Projects Section
  projects: [
    {
      id: 1,
      title: "AI-Powered Contract & TPM Risk Assistant",
      description: "Built AI-powered contract and TPM risk assistant services with RAG pipelines, PDF ingestion, MongoDB Atlas vector store for semantic search, and conversational memory.",
      technologies: ["Java", "Spring Boot 3", "Spring AI", "RAG", "MongoDB Atlas", "Python"],
      github: "https://github.com/sanjanakancharla",
      live: null,
      featured: true
    },
    {
      id: 2,
      title: "Agentic AI for Banking Contract Intelligence",
      description: "Developed an agentic AI proof-of-concept for banking compliance using LangGraph and LLM orchestration to identify risk signals and generate obligation summaries from complex contracts.",
      technologies: ["Python", "LangGraph", "LLM", "AI Agents"],
      github: "https://github.com/sanjanakancharla",
      live: null,
      featured: true
    },
    {
      id: 3,
      title: "ShopSmart E-commerce App",
      description: "Full-stack shopping app with Angular frontend and Spring Boot backend supporting product browsing, cart management, and checkout workflows with REST APIs.",
      technologies: ["Angular 17", "TypeScript", "Spring Boot", "REST APIs"],
      github: "https://github.com/sanjanakancharla",
      live: null,
      featured: true
    },
    {
      id: 4,
      title: "TaskFlow Todo App",
      description: "Responsive single-page todo application using Angular with component-based architecture, routing, filtered views, and reactive forms with custom validators.",
      technologies: ["Angular 17", "TypeScript", "RxJS", "HTML/CSS"],
      github: "https://github.com/sanjanakancharla",
      live: null,
      featured: false
    },
    {
      id: 5,
      title: "CI/CD Pipelines on Azure",
      description: "Built end-to-end CI/CD pipelines in Azure for automated creation and deployment of Docker images, streamlining the development lifecycle.",
      technologies: ["Azure DevOps", "Docker", "Jenkins", "Kubernetes"],
      github: null,
      live: null,
      featured: false
    },
    {
      id: 6,
      title: "Business Workflow Automation",
      description: "Automated workflows for business operations and financial teams at ING, achieving 90% time savings using Power Automate, Power Apps, and Microsoft 365 tools.",
      technologies: ["Power Automate", "Power Apps", "MS Dynamics 365"],
      github: null,
      live: null,
      featured: false
    }
  ],

  // Skills Section
  skills: {
    title: "Skills & Technologies",
    categories: [
      {
        name: "Frontend",
        items: ["Angular", "TypeScript", "RxJS", "HTML", "CSS", "Bootstrap"]
      },
      {
        name: "Backend",
        items: ["Java", "Spring Boot", "Spring Framework", "Hibernate", "JPA", "Python", "C++", "PHP", "MyBatis"]
      },
      {
        name: "Database",
        items: ["MySQL", "Oracle", "MongoDB", "Elasticsearch"]
      },
      {
        name: "Cloud & DevOps",
        items: ["AWS", "Azure", "Docker", "Kubernetes", "Red Hat OpenShift", "Jenkins", "Git"]
      },
      {
        name: "Observability",
        items: ["OpenTelemetry", "Jaeger", "Prometheus", "Grafana", "AppDynamics"]
      },
      {
        name: "Tools & Others",
        items: ["JIRA", "Postman", "AutoSys", "Power Automate", "Power Apps", "MS Dynamics 365"]
      }
    ]
  },

  // Contact Section
  contact: {
    title: "Get In Touch",
    description: "I'm always open to discussing new opportunities, AI projects, or collaborations. Feel free to reach out!",
    social: [
      {
        name: "GitHub",
        url: "https://github.com/sanjanakancharla",
        icon: "github"
      },
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/sanjanakancharla",
        icon: "linkedin"
      },
      {
        name: "Medium",
        url: "https://medium.com/@sanjanakancharla",
        icon: "medium"
      }
    ]
  }
};
